<div>
  <h2 mat-dialog-title>Afvis udsendelse</h2>
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>Kommentar</mat-label>
      <textarea matInput [(ngModel)]="comment"></textarea>
      <mat-hint>Indtast en kommentar til hvorfor udsendelsen afvises</mat-hint>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <span style="flex: 1 0 auto;"></span>
    <button mat-button color="primary" [mat-dialog-close]="{comment: comment}">Afvis</button>
  </mat-dialog-actions>
</div>
